var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"wrapper"},[_c('v-switch',{attrs:{"disabled":_vm.disabled,"input-value":_vm.status,"label":_vm.label},on:{"change":function($event){return _vm.onSwitchChange($event)}}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }